import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  full_name: string;
  role: 'super_admin' | 'admin';
  created_at: string;
};

export type Client = {
  id: string;
  nom: string;
  prenom?: string;
  entreprise?: string;
  email: string;
  telephone?: string;
  adresse?: string;
  ville?: string;
  secteur?: string;
  notes?: string;
  statut: 'prospect' | 'actif' | 'inactif' | 'perdu';
  created_by?: string;
  created_at: string;
  updated_at: string;
};

export type LigneDevis = {
  id?: string;
  devis_id?: string;
  designation: string;
  description?: string;
  quantite: number;
  unite: string;
  prix_unitaire: number;
  remise: number;
  montant_total: number;
  ordre: number;
};

export type Devis = {
  id: string;
  numero: string;
  client_id?: string;
  titre: string;
  description?: string;
  statut: 'brouillon' | 'envoye' | 'accepte' | 'refuse' | 'expire';
  date_emission: string;
  date_validite?: string;
  montant_ht: number;
  taux_tva: number;
  montant_ttc: number;
  devise: string;
  conditions?: string;
  notes_internes?: string;
  relance_j3_envoyee: boolean;
  created_by?: string;
  created_at: string;
  updated_at: string;
  client?: Client;
  lignes?: LigneDevis[];
};

export type SuiviAction = {
  id: string;
  client_id: string;
  devis_id?: string;
  type: 'appel' | 'email' | 'reunion' | 'relance' | 'note' | 'devis_envoye' | 'devis_accepte' | 'devis_refuse';
  titre: string;
  description?: string;
  date_action: string;
  rappel_at?: string;
  fait: boolean;
  created_by?: string;
  created_at: string;
};

export type ContactLead = {
  id: string;
  nom?: string;
  prenom?: string;
  email: string;
  telephone?: string;
  entreprise?: string;
  message?: string;
  service_interet?: string;
  source: string;
  converti: boolean;
  client_id?: string;
  relance_j3_envoyee: boolean;
  recap_semaine_inclus: boolean;
  created_at: string;
};
